module.exports = ".loader {\r\n    width: 60px;\r\n    margin: 0 auto;\r\n    position: relative;\r\n    top: 50px;\r\n}\r\n\r\n.card {\r\n    height: 130px;\r\n}\r\n\r\np {\r\n    margin-top: 15px !important;\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.css
// module id = ./src/app/shared/spinner/spinner.component.css
// module chunks = main